import { Input } from "formik-antd";
import { useCallback, useState } from "react";

/**
 * Generic component to display a password field in a formik form. This component
 * controls the placeholder text and onFocus/onBlur of the form. Note: the password
 * is never displayed as the API does not return it.
 */
export default function PasswordField({
  name,
  className = "password",
  passwordExists,
}: {
  name: string;
  className?: string;
  passwordExists: boolean;
}) {
  const [visible, setVisible] = useState(false);
  const onChange = useCallback((e) => {
    if (e.target.value) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, []);
  const onFocus = useCallback((e) => {
    e.target.placeholder = "";
  }, []);

  const onBlur = useCallback(
    (e) => {
      if (passwordExists) {
        e.target.placeholder = "***********";
      }
    },
    [passwordExists],
  );
  const getIcon = useCallback(
    () => (!visible ? () => null : undefined),
    [visible],
  );
  return (
    <Input.Password
      className={className}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={passwordExists ? "***********" : undefined}
      name={name}
      size="large"
      onChange={onChange}
      iconRender={getIcon()}
    />
  );
}
